/**
 * The only read site of the campaign feature flags. `vite.config.ts` builds its `define` map
 * from the resolved env config, so each flag below must have a default in that config's
 * static base — a key present nowhere would leave `process.env.<KEY>` in the bundle and throw
 * `ReferenceError: process is not defined` in the browser rather than read as off.
 *
 * With the default in place, the deployed env file (GitLab `ENV_CONFIG*`, not the `.dist`
 * templates) only has to declare a flag when it wants to override that default.
 */

/**
 * Whether a target group referenced by an ad group's pricing rule is locked: its
 * dimensions render readonly. Delete is disabled for such a group with the flag off too,
 * since the backend refuses it (`IN_USE`).
 *
 * Off by default — a locked target could not be edited at all, which is too blunt for
 * the one case it guards against. Sub-rules the target blocks are flagged instead
 * (`targetConflict`), so the damage is visible rather than prevented. Flip the flag in
 * `config/hprofits/*.env.js` to restore the lock; every consumer reads it through here.
 */
export const IS_TARGET_GROUP_LOCK_ENABLED = Boolean(process.env.FF_TARGET_GROUP_LOCK);
